export class Panel1OperativoI{
  diasOperativo : number;
  avanceEsperado : number;
  avanceReal : String;
  estado : number;
}
